module.exports = __webpack_public_path__ + "static/img/linglongfangong_icon.c5b5cef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/linglongfangong_icon.png
// module id = WVoD
// module chunks = 1